
const contextSelector = state => state.workspaceChanges && state.workspaceChanges.context;
const viewSelector = state =>  state.workspaceChanges && state.workspaceChanges.view;

module.exports = {
    contextSelector,
    viewSelector
};
